import { Link } from "gatsby";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Col, Container, Row } from "react-bootstrap";
import Img1 from "../../../images/locationgcc/qa/teemates.webp";
import Img2 from "../../../images/locationgcc/sa/pureplank.webp";
import Img3 from "../../../images/locationgcc/qa/equitrip.webp";

const CaseStudy = [
  {
    title: "TeeMates",
    description:
      "Teemates simplify the process of playing & engaging with fellow golf enthusiasts, offering a seamless and convenient platform, enabling you to connect with individuals sharing similar interests.",
    link: "teemates",
    Img: Img1,
    BgColor: "#738E45",
    TextColor: "#FFFFFF",
  },
  {
    title: "Pure Plank",
    description: "Your Ultimate Online Hub for Health and Home Workouts.",
    link: "pure-plank",
    Img: Img2,
    BgColor: "#121212",
    TextColor: "#FFFFFF",
  },
  {
    title: "Equitrip",
    description:
      "Equitrip serves as a digital hub where horse owners, transport companies, and industry stakeholders unite to enhance horse transportation's convenience through collaboration.",
    link: "equi-trip",
    Img: Img3,
    BgColor: "#132C51",
    TextColor: "#FFFFFF",
  },
];

const StoriesCase = () => {
  return (
    <div className="case_section">
      <Container className="h-100">
        <Row className="h-100">
          {CaseStudy.map((item, index) => (
            <Col
              xs={12}
              md={12}
              lg={10}
              xl={4}
              xxl={4}
              className="my-xl-auto m-lg-auto "
            >
              <div
                className="bg_case"
                style={{ backgroundColor: item.BgColor }}
              >
                <div className="case-content">
                  <h4 style={{ color: item.TextColor }}>{item.title}</h4>
                  <p style={{ color: item.TextColor }}>{item.description}</p>
                  <Link
                    to={
                      item.link
                        ? `/case-studies/${item.link}`
                        : "https://www.tekrevol.com/projects"
                    }
                    className="btn_case"
                  >
                    View Full Casestudy
                  </Link>
                </div>
                <div className="case-img">
                  <LazyLoadImage
                    src={item.Img}
                    effect="blur"
                    alt="Image"
                    className="img-fluid"
                  />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default StoriesCase;
